import { createApi } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../api/baseURL';
import { axiosBaseQuery } from '../axiosBaseQuery';
import { Response } from '../genericInterface';
import { IUser } from './interface';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  endpoints: (builder) => ({
    userLogin: builder.mutation<
      Response<IUser>,
      { email: string; password: string }
    >({
      query: (payload) => ({
        url: '/user/login',
        method: 'POST',
        body: payload
      })
    }),
    userResetPassword: builder.mutation<Response<IUser>, { email: string }>({
      query: (payload) => ({
        url: '/admin/reset-password-mail',
        method: 'POST',
        body: payload
      })
    }),
    validateToken: builder.mutation<Response<IUser>, { token: string }>({
      query: (payload) => ({
        url: '/admin/verify-reset-token',
        method: 'POST',
        body: payload
      })
    }),
    editResetPassword: builder.mutation<
      Response<IUser>,
      { token: string; newPassword: string }
    >({
      query: (payload) => ({
        url: '/admin/reset-password',
        method: 'PATCH',
        body: payload
      })
    })
  })
});

export const {
  useUserLoginMutation,
  useUserResetPasswordMutation,
  useEditResetPasswordMutation,
  useValidateTokenMutation
} = authApi;
